import {
	Box,
	CircularProgress,
	DialogActions,
	DialogContent,
	DialogContentText,
	Typography,
} from "@mui/material";
import { BaseConfirmationModalPropsType } from "../../../types/component.type";
import { BaseConfirmationModalWrapper } from "./styled";
import { BaseButton } from "../../button/styled";

export const BaseConfirmationModal: React.FC<
	BaseConfirmationModalPropsType
> = ({
	open,
	icon,
	handleClose,
	title,
	message,
	handleCallToAction,
	callToActionI,
	callToActionII,
	isLoadingI,
	isLoadingII,
	body,
}) => {
	return (
		<BaseConfirmationModalWrapper open={open} onClose={handleClose}>
			<DialogContent className="modal-content">
				{icon && (
					<Box component={"div"} className="icon-box">
						{icon}
					</Box>
				)}
				<DialogContentText
					variant="h2"
					fontFamily={"Poppins"}
					fontWeight={700}
					fontSize={24}
					lineHeight={"normal"}
					color={"var(--midnight-blue-color)"}
					marginBlock={"0 calc(var(--basic-margin)/2)"}
					whiteSpace={"normal"}
					textAlign={"center"}
					className="title"
				>
					{title}
				</DialogContentText>
				{message && (
					<DialogContentText
						variant="body1"
						fontFamily={"Inter"}
						fontWeight={500}
						fontSize={16}
						lineHeight={"normal"}
						color={"var(--semi-dark-color)"}
						whiteSpace={"normal"}
						textAlign={"center"}
					>
						{message}
					</DialogContentText>
				)}
				{body}
			</DialogContent>
			<DialogActions
				sx={{
					gap: "calc(var(--flex-gap)/2)",
					justifyContent: "space-between",
					flexDirection: { mobile: "column", miniTablet: "row" },
					padding: "0 var(--basic-padding) var(--basic-padding)",
					alignItems: { mobile: "flex-start", miniTablet: "center" },
				}}
			>
				<Box overflow={"hidden"} flex={1} width={"-webkit-fill-available"}>
					<BaseButton
						variant="contained"
						onClick={(e) => handleCallToAction?.(e, "callToActionI")}
						padding={
							"calc(var(--basic-padding)/4) calc(var(--basic-padding))"
						}
						sx={{
							width: "inherit",
						}}
					>
						{isLoadingI ? (
							<CircularProgress color="inherit" className="loader" />
						) : (
							<Typography
								variant={"button"}
								fontFamily={"inherit"}
								fontWeight={"inherit"}
								fontSize={"inherit"}
								lineHeight={"inherit"}
								color={"inherit"}
								textTransform={"inherit"}
							>
								{callToActionI}
							</Typography>
						)}
					</BaseButton>
				</Box>
				<Box
					flex={1}
					overflow={"hidden"}
					marginLeft={"0 !important"}
					width={"-webkit-fill-available"}
				>
					<BaseButton
						variant="contained"
						onClick={(e) => handleCallToAction?.(e, "callToActionII")}
						padding={
							"calc(var(--basic-padding)/4) calc(var(--basic-padding))"
						}
						sx={{
							width: "inherit",
						}}
					>
						{isLoadingII ? (
							<CircularProgress color="inherit" className="loader" />
						) : (
							<Typography
								variant={"button"}
								fontFamily={"inherit"}
								fontWeight={"inherit"}
								fontSize={"inherit"}
								lineHeight={"inherit"}
								color={"inherit"}
								textTransform={"inherit"}
							>
								{callToActionII}
							</Typography>
						)}
					</BaseButton>
				</Box>
			</DialogActions>
		</BaseConfirmationModalWrapper>
	);
};
